export interface RouteMetadataDefinition {
  title: string;
  description: string;
  url: string;
  image: string;
  imageWidth: number;
  imageHeight: number;
  imageAlt: string;
  imageType: string;
}

export interface MetadataTag {
  attribute: 'name' | 'property';
  key: string;
  content: string;
}

export const DEFAULT_ROUTE_METADATA: RouteMetadataDefinition = {
  title: 'Autoclipper - Ecossistema de Clipadores',
  description: 'Autoclipper - Plataforma de edição de vídeo com IA para criar conteúdo viral',
  url: 'https://app.autoclipper.live',
  image: 'https://app.autoclipper.live/images/autoclipper-og-image.png',
  imageWidth: 1200,
  imageHeight: 630,
  imageAlt: 'Autoclipper - Ecossistema de Clipadores',
  imageType: 'image/png',
};

const SUPER_HERO_ROUTE_METADATA: RouteMetadataDefinition = {
  title: 'El Gato × Super Hero | Autoclipper',
  description: 'Participe da campanha de clipes El Gato × Super Hero e concorra a prêmios com seus melhores cortes.',
  url: 'https://app.autoclipper.live/super-hero',
  image: 'https://app.autoclipper.live/images/super-hero-og-v1.jpg',
  imageWidth: 1600,
  imageHeight: 900,
  imageAlt: 'Campanha de clipes El Gato × Super Hero no Autoclipper',
  imageType: 'image/jpeg',
};

/** Only the fixed campaign entry has public campaign sharing metadata. */
export function getRouteMetadata(pathname: string): RouteMetadataDefinition {
  return pathname === '/super-hero' || pathname === '/super-hero/'
    ? SUPER_HERO_ROUTE_METADATA
    : DEFAULT_ROUTE_METADATA;
}

/** Shared by the crawler-visible HTML build and the client-side route updater. */
export function getMetadataTags(metadata: RouteMetadataDefinition): MetadataTag[] {
  return [
    { attribute: 'name', key: 'description', content: metadata.description },
    { attribute: 'property', key: 'og:site_name', content: 'Autoclipper' },
    { attribute: 'property', key: 'og:locale', content: 'pt_BR' },
    { attribute: 'property', key: 'og:type', content: 'website' },
    { attribute: 'property', key: 'og:title', content: metadata.title },
    { attribute: 'property', key: 'og:description', content: metadata.description },
    { attribute: 'property', key: 'og:url', content: metadata.url },
    { attribute: 'property', key: 'og:image', content: metadata.image },
    { attribute: 'property', key: 'og:image:type', content: metadata.imageType },
    { attribute: 'property', key: 'og:image:width', content: String(metadata.imageWidth) },
    { attribute: 'property', key: 'og:image:height', content: String(metadata.imageHeight) },
    { attribute: 'property', key: 'og:image:alt', content: metadata.imageAlt },
    { attribute: 'name', key: 'twitter:card', content: 'summary_large_image' },
    { attribute: 'name', key: 'twitter:site', content: '@autoclipper' },
    { attribute: 'name', key: 'twitter:title', content: metadata.title },
    { attribute: 'name', key: 'twitter:description', content: metadata.description },
    { attribute: 'name', key: 'twitter:image', content: metadata.image },
    { attribute: 'name', key: 'twitter:image:alt', content: metadata.imageAlt },
  ];
}
